angular.module('aprima-core-ui').filter('apFilterFeature', ['ServerInfoRepository', '_', function (ServerInfoRepository, _) {
    'use strict';
    return function (inputCollection, featureParam) {
        var fn = _.isArray(inputCollection) ? _.filter : _.pickBy;

        return fn(inputCollection, function(item) {
            if(item[featureParam]) {

                var splitRequiredFeatures = item[featureParam].split(',');
                var isFeatureSupported = ServerInfoRepository.isFeatureSupported(splitRequiredFeatures);

                if(isFeatureSupported){
                    return true;
                }
            }
            else{
                return true;
            }
        });
    };
}]);
